import markApplyRecordReducer from "./markApplyRecordReducer";
import changeApplyRecordReducer from "./changeApplyRecordReducer";
import caseApplyRecordReducer from "./caseApplyRecordReducer";


const processingApplyRecordReducer = {
    processingMarkApplyRecords: markApplyRecordReducer,
    processingChangeApplyRecords: changeApplyRecordReducer,
    processingCaseApplyRecords: caseApplyRecordReducer,

}

export default processingApplyRecordReducer